import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-sm border border-gray-100">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Terms and Conditions</h1>
        <p className="text-sm text-gray-500 mb-8 text-center">Last Updated: August 20, 2026</p>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing and using the iAssets platform (including our mobile applications and website), you agree to comply with and be bound by these Terms and Conditions. If you do not agree to these terms, please refrain from using our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Platform Role and Facilitation</h2>
            <p>
              iAssets acts solely as a technological facilitator connecting property owners, buyers, and users with verified real estate professionals, including Valuers, Engineers, Legal Experts, and Agents. We do not directly provide technical, legal, or valuation services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Valuations and Estimates Disclaimer</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>Property valuations and estimated rates provided through the app's calculator are indicative and for reference purposes only. They are based on Sub-Registrar guidelines and active market rates.</li>
              <li>Final deliverables, certified valuations, and legal opinions are the sole responsibility of the respective assigned professionals.</li>
              <li>Service timelines and construction estimates are subject to change based on actual site conditions and material costs.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. User Responsibilities</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>All details submitted regarding property dimensions, location, and ownership must be accurate and authentic.</li>
              <li>Users are solely responsible for keeping their login credentials and OTPs secure.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Professional Obligations</h2>
            <p>
              Professionals (Valuers, Agents, etc.) registering on the platform are subject to administrative review and verification. Professionals must maintain valid certifications and provide services in accordance with local laws and industry standards.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;